import { render, staticRenderFns } from "./GjwTable.vue?vue&type=template&id=1ada926d&scoped=true"
import script from "./GjwTable.vue?vue&type=script&lang=js"
export * from "./GjwTable.vue?vue&type=script&lang=js"
import style0 from "./GjwTable.vue?vue&type=style&index=0&id=1ada926d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ada926d",
  null
  
)

export default component.exports